import { IHiddenRanges } from 'src/interfaces/global';
import { addFramesStyles, addTransition } from 'src/styles/theme/utils/functions';
import styled from 'styled-components';

export const StyledBGImage = styled.div<IHiddenRanges>`
	position: fixed;
	bottom: 0;
	left: 0;
	right: 0;
	top: 0;
	z-index: -1;

	${addTransition()}
	${(p) => addFramesStyles(p)}
`;
